import React, { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface StepLayoutProps {
  children: ReactNode;
  title?: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
  contentClassName?: string;
  fullWidth?: boolean;
  onBack?: () => void;
}

/**
 * Layout padrão para todas as etapas do onboarding, garantindo consistência visual
 */
export const StepLayout: React.FC<StepLayoutProps> = ({
  children,
  title,
  description,
  icon,
  className,
  contentClassName,
  fullWidth = false,
  onBack,
}) => {
  return (
    <div className={cn("w-full", fullWidth ? "max-w-full" : "max-w-3xl mx-auto", className)}>
      <Card className="shadow-md">
        {(title || description) && (
          <CardHeader className="p-6 pb-0">
            {title && (
              <CardTitle className="flex items-center gap-2">
                {icon && <span className="text-primary">{icon}</span>}
                {title}
              </CardTitle>
            )}
            {description && <CardDescription>{description}</CardDescription>}
            {onBack && (
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={onBack}
                className="absolute top-4 left-4 p-2 h-8 w-8"
              >
                <ArrowLeft className="h-4 w-4" />
              </Button>
            )}
          </CardHeader>
        )}
        <CardContent className={cn("p-6", contentClassName)}>
          {children}
        </CardContent>
      </Card>
    </div>
  );
}; 